import React from 'react'
import Typography from '@mui/material/Typography'
import { classes, FooterStyles } from './style'

const Footer = () => {
  return (
        <FooterStyles className={classes.root}>
          <Typography>Copyright 2023 E-VERSE | Made in Miami</Typography>
        </FooterStyles>
  )
}

export default Footer
